/* Article page: reading progress, and the contents rail.
   ------------------------------------------------------------------------ */
(function () {
  var root = document.querySelector('[data-article]');
  var bar = document.querySelector('[data-art-progress]');
  if (!root && !bar) return;

  var body = root && root.querySelector('[data-art-body]');
  var rail = root && root.querySelector('[data-art-rail]');
  var slot = root && root.querySelector('[data-art-toc-slot]');

  /* ---------------------------------------------------------------- rail --
     The author writes a contents list into the body: an <h2> whose text is
     "Table of Contents" followed by a <ul> of anchor links. We move that list
     into the rail rather than building a second one from the headings, so
     there is one list and it stays theirs — including the order and wording
     they chose, and any heading they deliberately left out of it.

     The <ul> is moved, not copied. The heading it belonged to is hidden rather
     than removed, so its id still answers a link from elsewhere.

     Below the rail's breakpoint nothing moves: the list stays in the body
     where it reads fine, and the rail is never shown.
  ---------------------------------------------------------------------- */
  var RAIL_AT = '(min-width: 64rem)';
  var moved = null;
  var tocHeading = null;

  function findToc() {
    if (!body) return null;
    var headings = body.querySelectorAll('h2');
    for (var i = 0; i < headings.length; i++) {
      if (!/table of contents/i.test(headings[i].textContent || '')) continue;
      var list = headings[i].nextElementSibling;
      if (list && (list.tagName === 'UL' || list.tagName === 'OL')) {
        return { heading: headings[i], list: list };
      }
    }
    return null;
  }

  function mountRail() {
    if (moved || !slot) return;
    var found = findToc();
    if (!found) return;
    tocHeading = found.heading;
    moved = found.list;
    tocHeading.hidden = true;
    slot.appendChild(moved);
    rail.hidden = false;
    spy();
  }

  function unmountRail() {
    if (!moved) return;
    tocHeading.hidden = false;
    tocHeading.parentNode.insertBefore(moved, tocHeading.nextSibling);
    moved = null;
    tocHeading = null;
    rail.hidden = true;
  }

  /* --------------------------------------------------------------- scrollspy
     Which section am I in. The links already point at real heading ids, so the
     targets come from the list itself and nothing needs generating.

     Position is read on scroll rather than through an IntersectionObserver
     because "the last heading I have passed" is a question about one number,
     and an observer answers a different question — which headings are on
     screen — that goes wrong when a section is taller than the viewport and
     nothing is intersecting at all.
  ------------------------------------------------------------------------ */
  var targets = [];

  function collect() {
    targets = [];
    if (!moved) return;
    var links = moved.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < links.length; i++) {
      var id = decodeURIComponent(links[i].getAttribute('href').slice(1));
      var el = id && document.getElementById(id);
      if (el) targets.push({ link: links[i], el: el });
    }
  }

  var current = null;

  function spy() {
    if (!moved) return;
    if (!targets.length) collect();
    if (!targets.length) return;

    /* A third of the way down the viewport: a heading counts as "current"
       once it has come up past the reading line, not the moment it appears. */
    var line = window.innerHeight / 3;
    var found = null;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].el.getBoundingClientRect().top <= line) found = targets[i];
    }
    if (found === current) return;
    if (current) current.link.removeAttribute('aria-current');
    if (found) found.link.setAttribute('aria-current', 'true');
    current = found;
  }

  /* ------------------------------------------------------------- progress --
     How much of the article is behind you — measured against the body, not
     the document, so the footer and the comment form do not count as reading.
  ------------------------------------------------------------------------ */
  function progress() {
    if (!bar || !body) return;
    var box = body.getBoundingClientRect();
    var scrolled = -box.top;
    var runway = box.height - window.innerHeight;
    var pct = runway > 0 ? scrolled / runway : (scrolled > 0 ? 1 : 0);
    if (pct < 0) pct = 0;
    if (pct > 1) pct = 1;
    bar.style.transform = 'scaleX(' + pct + ')';
  }

  function onScroll() {
    progress();
    spy();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    onScroll();
  }, { passive: true });

  /* The rail comes and goes with the breakpoint. addEventListener on the query
     rather than a resize handler, so it fires once per crossing. */
  if (window.matchMedia) {
    var mq = window.matchMedia(RAIL_AT);
    var apply = function () {
      if (mq.matches) { mountRail(); } else { unmountRail(); }
      collect();
      current = null;
      onScroll();
    };
    if (mq.addEventListener) { mq.addEventListener('change', apply); }
    else if (mq.addListener) { mq.addListener(apply); }
    apply();
  }

  onScroll();
}());
